// extracted by mini-css-extract-plugin
export default {"login":"LogIn_login__BoGcm","Form":"LogIn_Form__Fpgk0","LogInButtonDiv":"LogIn_LogInButtonDiv__TY+Xf","Title":"LogIn_Title__DFL+6","Error":"LogIn_Error__Spzpb"};